/* eslint-disable no-underscore-dangle */
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

L.Marker.Measurement = L[L.Layer ? 'Layer' : 'Class'].extend({
  options: {
    pane: 'markerPane',
    snapIgnore: true,
  },

  /**
   * Inicia a função
   * 
   * @param {number} latlng 
   * @param {object} measurement medidas
   * @param {string} title Titulo
   * @param {number} rotation 
   * @param {object} options Menu com opçoes
   * @param {string} asTooltip Descrição
   */
  initialize: function (
    latlng,
    measurement,
    title,
    rotation,
    options,
    asTooltip
  ) {
    L.setOptions(this, options);

    this._latlng = latlng;
    this._measurement = measurement;
    this._title = title;
    this._rotation = rotation;
    this._asTooltip = asTooltip;
  },

  addTo: function (map) {
    map.addLayer(this);
    return this;
  },

  onAdd: function (map) {
    this._map = map;
    var pane = this.getPane ? this.getPane() : map.getPanes().markerPane;
    var el = (this._element = L.DomUtil.create(
      'div',
      'leaflet-zoom-animated leaflet-measure-path-measurement',
      pane
    ));
    var inner = L.DomUtil.create(
      'div',
      this._asTooltip ? 'as-tooltip' : '',
      el
    );
    inner.title = this._title;
    inner.innerHTML = this._measurement;

    map.on('zoomanim', this._animateZoom, this);

    this._setPosition();
  },

  onRemove: function (map) {
    map.off('zoomanim', this._animateZoom, this);
    var pane = this.getPane ? this.getPane() : map.getPanes().markerPane;
    pane.removeChild(this._element);
    this._map = null;
  },

  _setPosition: function () {
    L.DomUtil.setPosition(
      this._element,
      this._map.latLngToLayerPoint(this._latlng)
    );
    this._element.style.transform += ' rotate(' + this._rotation + 'rad)';
  },

  _animateZoom: function (opt) {
    var pos = this._map
      ._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center)
      .round();
    L.DomUtil.setPosition(this._element, pos);
    this._element.style.transform += ' rotate(' + this._rotation + 'rad)';
  },
});

  /**
   * L.marker.measurement
   * 
   * @param {number} latlng 
   * @param {object} measurement medidas
   * @param {string} title Titulo
   * @param {number} position
   * @param {*} rotation 
   * @param {object} options Menu com opçoes
   * 
   * @returns
   */
L.marker.measurement = function (
  latLng,
  measurement,
  title,
  position,
  rotation,
  options
) {
  return new L.Marker.Measurement(
    latLng,
    measurement,
    title,
    position,
    rotation,
    options
  );
};
